import { render } from "./SandboxDetail.vue?vue&type=template&id=40eb6adc&scoped=true"
import script from "./SandboxDetail.vue?vue&type=script&lang=js"
export * from "./SandboxDetail.vue?vue&type=script&lang=js"

import "./SandboxDetail.vue?vue&type=style&index=0&id=40eb6adc&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40eb6adc"]])

export default __exports__